import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_003.jpg';
page.images = [
  {
    imageId: 'page003_zoom0',
    rectangle: {
      x: 904,
      y: 23,
      width: 730,
      height: 847,
    },
    imageSrc: 'images/page003/002 1.jpg',
  },
];
// page.paint = [
//   {
//     id: 'page010_game2',
//     icon: 'ikona_cw2',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Znajdź szczegóły, którymi różnią się obrazki.  ',
//       audio: 'files/page010/z10c2.mp3',
//       item: {
//         path: 'informatyka/files/page010/z.10cw.2.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 0,
//     },
//   },
//   {
//     id: 'page010_game3',
//     icon: 'ikona_cw3',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Powiększ fragmenty rysunku za pomocą narzędzia <i>Lupa</i>.  ',
//       audio: 'files/page010/z10c3.mp3',
//       item: {
//         path: 'informatyka/files/page010/z.10cw.3.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 100,
//     },
//   },
//   {
//     id: 'page009_game1',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Dorysuj brakujące linie narzędziem Ołówek, a następnie pokoloruj rysunek.  ',
//       audio: 'files/page009/z9c1.mp3',
//       item: {
//         path: 'informatyka/files/page009/z.9cw.1.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 200,
//     },
//   },
//   {
//     id: 'page009_game2',
//     icon: 'ikona_cw2',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Otocz pętlą wybrane obrazki.  ',
//       audio: 'files/page009/z9c2.mp3',
//       item: {
//         path: 'informatyka/files/page009/z.9cw.2.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 300,
//     },
//   },
//   {
//     id: 'page009_game3',
//     icon: 'ikona_cw3',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Dokończ rysunek.   ',
//       audio: 'files/page009/z9c3.mp3',
//       item: {
//         path: 'informatyka/files/page009/z.9cw.3.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 400,
//     },
//   },
//   {
//     id: 'page008_game4',
//     icon: 'ikona_cw4',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Skopiuj rysunek domku i wklej go.  ',
//       audio: 'files/page008/z8c4.mp3',
//       item: {
//         path: 'informatyka/files/page008/z.8cw.4.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 500,
//     },
//   },
//   {
//     id: 'page008_game2',
//     icon: 'ikona_cw2',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Zaznacz obrazki zabawek.  ',
//       audio: 'files/page008/z8c2.mp3',
//       item: {
//         path: 'informatyka/files/page008/z.8cw.2.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 600,
//     },
//   },
//   {
//     id: 'page008_game3',
//     icon: 'ikona_cw3',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Skopiuj obrazek pajacyka i wklej go do pustej ramki.  ',
//       audio: 'files/page008/z8c3.mp3',
//       item: {
//         path: 'informatyka/files/page008/z.8cw.3.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 700,
//     },
//   },
//   {
//     id: 'page006_game4',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Narysuj ikonę.  ',
//       audio: 'files/page006/z6c4.mp3',
//       item: {
//         path: 'informatyka/files/page006/z.6cw.4.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 800,
//     },
//   },
//   {
//     id: 'page005_game2',
//     icon: 'ikona_cw2',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Pokoloruj rysunek i zapisz zmiany w pliku.  ',
//       audio: 'files/page005/z5c2.mp3',
//       item: {
//         path: 'informatyka/files/page005/z.5cw.2.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 900,
//     },
//   },
//   {
//     id: 'page005_game3',
//     icon: 'ikona_cw3',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Narysuj swoją ulubioną zabawę. Dokończ rysunek i go pokoloruj.  ',
//       audio: 'files/page005/z5c3.mp3',
//       item: {
//         path: 'informatyka/files/page005/z.5cw.3.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 1000,
//     },
//   },
//   {
//     id: 'page004_game1',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Uzupełnij rysunek i go pokoloruj.  ',
//       audio: 'files/page004/z4c1.mp3',
//       item: {
//         path: 'informatyka/files/page004/z.4cw.1.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 1100,
//     },
//   },
//   {
//     id: 'page004_game2',
//     icon: 'ikona_cw2',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Usuń śmieci i pokoloruj rysunek.  ',
//       audio: 'files/page004/z4c2.mp3',
//       item: {
//         path: 'informatyka/files/page004/z.4cw.2.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 1200,
//     },
//   },
//   {
//     id: 'page004_game3',
//     icon: 'ikona_cw3',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Dokończ rysunek.  ',
//       audio: 'files/page004/z4c3.mp3',
//       item: {
//         path: 'informatyka/files/page004/z.4cw.3.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 1300,
//     },
//   },
//   {
//     id: 'page003_game3',
//     icon: 'ikona_cw3',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Pokoloruj rysunek dziecka.  ',
//       audio: 'files/page003/z3c3.mp3',
//       item: {
//         path: 'informatyka/files/page003/z.3cw.3.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: RIGHT,
//       y: 1400,
//     },
//   },
// ];
// page.presentation = [
//   {
//     id: 'p0',
//     icon: 'ikonaPrezentacja',
//     tooltip: 'Plansze',
//     multibookType: 'demo_gwk_kl1_prezentacje',
//     pos: {
//       x: RIGHT,
//       y: 0,
//     },
//     rectangle: {
//       id: 'page001_rect6',
//     },
//   },
// ];
// page.scratchPad = [
//   {
//     id: 'page002_game1',
//     icon: 'ikonaBrudnopis',
//     color: '#FF000000',
//     pos: {
//       x: RIGHT,
//       y: 192,
//     },
//     item: {
//       id: 'page002_game1',
//     },
//     rectangle: {
//       id: 'page001_rect1',
//     },
//   },
//   {
//     id: 'page001_game0',
//     icon: 'ikonaBrudnopis',
//     color: '#FF000000',
//     pos: {
//       x: RIGHT,
//       y: 1485,
//     },
//     item: {
//       id: 'page001_game0',
//     },
//     rectangle: {
//       id: 'page001_rect0',
//     },
//   },
// ];
// page.rectangle = [
//   {
//     id: 'page001_rect0',
//
//     tooltip: '',
//     color: '#FF000000',
//     linked: ['page001_game0'],
//     x: 113,
//     y: 1485,
//     width: 1700,
//     height: 917,
//   },
//   {
//     id: 'page001_rect1',
//
//     tooltip: '',
//     color: '#FF000000',
//     linked: ['page002_game1'],
//     x: 113,
//     y: 192,
//     width: 1697,
//     height: 1280,
//   },
//   {
//     id: 'page001_rect6',
//
//     tooltip: '',
//     color: '#FF000000',
//     linked: ['p0'],
//     x: 640,
//     y: 45,
//     width: 640,
//     height: 150,
//   },
// ];
//

export default page;
